import { cn } from '#app/utils/misc'
import { RichContent } from './richContent'
import { H3 } from './typography'

type Image = {
	url: string
	height?: number
	width?: number
}

type ImageText = {
	image: Image
	title?: string
	textContent: any
	imageLeftRight: 'Left' | 'Right'
}

export const ImageText = ({
	image,
	title,
	textContent,
	imageLeftRight,
}: ImageText) => {
	const classes = cn('flex flex-col gap-4', {
		'lg:flex-row-reverse': imageLeftRight === 'Left',
		'lg:flex-row': imageLeftRight === 'Right',
	})

	return (
		<div className={classes}>
			<div className="lg:w-2/3">
				{title && <H3>{title}</H3>}
				<RichContent content={textContent.raw} />
			</div>
			<div className="lg:w-1/3">
				<img src={image.url} />
			</div>
		</div>
	)
}
